import React, { useEffect, useState } from "react"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import _ from "lodash"
import { Grid, Tooltip, Box, Button, IconButton, Menu, MenuList, MenuItem, Chip, Switch, Typography, Tabs, Tab } from "@material-ui/core"
import MoreVertIcon from "@material-ui/icons/MoreVert"
import { useHistory, useParams } from "react-router-dom"
import { getStatusColor, CASE_ACTIVITY, useInterval } from "../../utils"
import { useSelector, useDispatch } from "react-redux"
import TableView from "../common/TableView/TableView"
import { useTranslation } from "react-i18next"
import moment from "moment"
import { getCharacterCount, getUserloginDetails, setPageNumberUserLoginDetails } from "../../actions/billingActions"

const useStyles = makeStyles((theme) => ({
	gridItem: {
		paddingBottom: 12,
	},

	caseDetails: {
		"& .MuiDataGrid-cell": {
			padding: "0 16px",
		},
		"& .MuiChip-root": {
			borderRadius: "4px",
		},
	},
	caseMode: {
		display: "flex",
		alignItems: "center",
		margin: "-7px -10px",
		"& p": { color: theme.palette.status.maintenanceMode },
	},
}))

const UserLoginDetails = (props) => {
	const { recordsPerPage, setRecordsPerPage, caseStatus, dateRange, pageNumber, setPageNumber } = props
	const classes = useStyles()
	const history = useHistory()
	const params = useParams()
	const theme = useTheme()
	const caseId = params.id
	const dispatch = useDispatch()
	const [t] = useTranslation("global")
	const SERVER_MODE = "server"
	const userLoginDetails = useSelector((state) => state?.billingReducers?.userLoginDetails)
	const userLoginDetailsLoading = useSelector((state) => state?.billingReducers?.userLoginDetailsLoading)
	const totalUserLoginDetails = useSelector((state) => state?.billingReducers?.totalUserLoginDetails)
	const pageNumberUserLoginDetails = useSelector((state) => state?.billingReducers?.pageNumberUserLoginDetails)
	const [userLoginLocalDetails, setUserLoginLocalDetails] = useState([])

	const getRows = () => {
		const tableData = userLoginDetails
			? userLoginDetails?.map((userDetails) => ({
					id: userDetails?.id,
					firstName: userDetails?.user_info[0]?.first_name,
					lastName: userDetails?.user_info[0]?.last_name,
					date: moment(moment.utc(userDetails?.timestamp)).local().format("MM/DD/YYYY"),
					time: moment(moment.utc(userDetails?.timestamp)).local().format("HH:mm:ss"),
					caseName: userDetails?.case_info[0]?.name,
					caseStatus: userDetails?.case_info[0]?.case_mode,
			  }))
			: []
		return tableData
	}

	const getColumns = () => {
		return [
			{
				field: "id",
				sortable: false,
				hide: true,
			},
			{
				field: "firstName",
				headerName: t("billing.userDetails.firstName"),
				sortable: false,
				width: 250,
			},
			{
				field: "lastName",
				headerName: t("billing.userDetails.lastName"),
				sortable: false,
				width: 250,
			},
			{
				field: "date",
				headerName: t("billing.userDetails.date"),
				sortable: false,
				width: 200,
			},
			{
				field: "time",
				headerName: t("billing.userDetails.time"),
				sortable: false,
				width: 200,
			},
			{
				field: "caseName",
				headerName: t("billing.userDetails.caseName"),
				sortable: false,
				width: 400,
			},
			{
				field: "caseStatus",
				headerName: t("billing.userDetails.caseStatus"),
				sortable: false,
				width: 200,
				renderCell: (params) => (
					<Chip
						label={params?.row?.caseStatus}
						size="small"
						style={{
							textTransform: "capitalize",
							color: getStatusColor(params?.row?.caseStatus, theme).color,
							backgroundColor: getStatusColor(params?.row?.caseStatus, theme).background,
						}}
					/>
				),
			},
		]
	}

	const handlePageChange = (newPage) => {
		//setPageNumber(newPage)
		dispatch(setPageNumberUserLoginDetails(newPage))
		const skipCount = newPage === 1 ? 0 : (newPage - 1) * recordsPerPage
		const data = {
			case_id: caseStatus?.project_id,
			start_date: dateRange?.startDate ? moment(dateRange?.startDate).format("YYYY-MM-DD") : "",
			end_date: dateRange?.endDate ? moment(dateRange?.endDate).format("YYYY-MM-DD") : "",
			return_count: recordsPerPage || 5,
			skip_count: skipCount,
		}
		dispatch(getUserloginDetails(data))
	}

	const handlePageSizeChange = (newPageSize) => {
		setRecordsPerPage(newPageSize)
	}

	return (
		<div className={classes.caseDetails}>
			<Typography style={{ ...theme.typography.subTitle1, margin: "40px 0 16px 0" }}>
				{t("billing.userDetails.userLoginDetails")}
			</Typography>
			<TableView
				columns={getColumns()}
				rows={getRows()}
				isLoading={userLoginDetailsLoading}
				pageInfo={{
					page: pageNumberUserLoginDetails,
					pagination: true,
					pageSize: recordsPerPage || 5,
					rowsPerPageOptions: [5, 10],
					totalRowCount: totalUserLoginDetails || 0,
					paginationMode: "server",
					handlePageChange,
					handlePageSizeChange,
				}}
				sortInfo={{
					sortingMode: "server",
					sortModel: [],
					onSortModelChange: () => {},
				}}
				checkboxSelection={false}
				footerInfo={{
					hideFooter: false,
					hideSelectionCount: true,
				}}
				topBarInfo={{
					show: true,
					rightSection: "",
				}}
				totalCountText={`Total count: ${totalUserLoginDetails || 0}`}
				showDownloadButton={false}
				showColumnsButton={false}
			/>
		</div>
	)
}

export default UserLoginDetails
